<template>
    <div>
        <div key="task" v-if="selectedBar=='task'">
            <SafeTask/>
        </div>
        <div key="point" v-if="selectedBar=='point'">
            <SafePoint/>
        </div>
        <Tabbar v-model="selectedBar">
            <TabbarItem name="task" icon="notes-o">打卡任务</TabbarItem>
            <!-- <TabbarItem name="point" icon="notes-o">打卡点</TabbarItem> -->
        </Tabbar>
    </div>
</template>

<script>
    import {Tabbar, TabbarItem, Tabs} from "vant";
    import SafeTask from "./tab/SafeTask"
    import SafePoint from "./tab/SafePoint"


    export default {
        components: {
            Tabbar, TabbarItem,
            SafeTask, SafePoint
        },
        props: {},
        data() {
            return {
                selectedBar: 'task',
            }
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    }
</script>

<style lang="less">
</style>
